import { useWeb3React } from '@web3-react/core';
import { getRockRelayerContract } from '../utils/contractHelpers';
import { rockRelayerContract } from '../utils/Enviroment';
import { getSignedData, getSwapRawTransaction, getUniswapTokenQuote } from '../utils/services/service';
import useWeb3 from './useWeb3';
import BigNumber from 'bignumber.js';

const useUniswapV3 = () => {
    const web3 = useWeb3();
    const { account } = useWeb3React();
    const getV3Quote = async (payload) => {
        try {
            const response = await getUniswapTokenQuote(payload)
            return response
        }
        catch (error) {
            console.error("Error getting V3 Quote:", error);
        }
    }
    const getDataToSign = async (payload) => {
        try {
            const response = await getSignedData(payload)
            const { domain, types, values } = response?.data?.data?.signature
            const permitData = response?.data?.data?.permit
            return { domain, types, values, permitData }
        }
        catch (error) {
            console.error("Error getting Signed Data:", error);
        }
    }

    const getSwapTransaction = async (payload) => {
        try {
            const getTransactionData = await getSwapRawTransaction(payload)
            const rawTransaction = getTransactionData?.data?.data
            return rawTransaction
        } catch (error) {
            console.error("Error getting Signed Data:", error);
        }
    }

    const rockRelayerTransactions = async (tradeAmount, rockAddress, isBuyTrade, time) => {
        try {
            const getRelayerContract = await getRockRelayerContract(rockRelayerContract, web3)

            let gasPrice = await web3.eth.getGasPrice();
            gasPrice = parseInt(gasPrice);

            const feeData = await web3.eth.getFeeHistory(1, 'latest', [25, 50, 75]);
            const baseFee = new BigNumber(feeData.baseFeePerGas[0]); // Base Fee from last block
            const priorityFee = new BigNumber(web3.utils.toWei("2", "gwei")); // 2 Gwei priority fee

            // Ensure maxFeePerGas is at least baseFee + priorityFee
            const maxFeePerGas = BigNumber.maximum(baseFee.multipliedBy(2), priorityFee.plus(baseFee));
            const maxPriorityFeePerGas = priorityFee;

            if (isBuyTrade) {
                const tradeAmountInWei = web3.utils.toWei(tradeAmount, "ether");
                const transaction = getRelayerContract?.methods?.buyWithETH(
                    rockAddress, account, time
                ).send({
                    from: account,
                    gasPrice: gasPrice,
                    maxFeePerGas,
                    maxPriorityFeePerGas,
                    value: tradeAmountInWei
                });
                return transaction;
            }
            else {
                const tradeAmountInWei = web3.utils.toWei(tradeAmount, "ether");
                const transaction = await getRelayerContract?.methods?.sell(
                    tradeAmountInWei, rockAddress, account, true, time
                ).send({
                    from: account,
                    gasPrice: gasPrice,
                    maxFeePerGas,
                    maxPriorityFeePerGas,
                });
                return transaction;
            }

        } catch (error) {
            console.error("Error in transaction", error);
            throw new Error(error.message || "Transaction failed");
        }
    }
    return { getV3Quote, getDataToSign, getSwapTransaction, rockRelayerTransactions }
}

export default useUniswapV3
